import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  QueryList,
  ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { SwiperOptions } from 'swiper';
import { CarouselSlideDirective } from './carousel-slide.component';

@Component({
    selector: 'lui-carousel',
    templateUrl: './carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CarouselComponent implements AfterViewInit {
  @ContentChildren(CarouselSlideDirective, { descendants: true })
  slides!: QueryList<CarouselSlideDirective>;

  @Input() config: SwiperOptions = {};

  destroy = new Subject<void>();

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.slides.changes.subscribe(() => this.cd.markForCheck());
  }
}
